import { useCallback, useEffect, useState } from "react";
import cancelIcon from "../../assets/cancelIcon.svg";
import axios from "axios";
import debounce from "../../utils/Debounce";
import LoadingComponent from "../../components/Loading";
import { format } from "date-fns";
import axiosCMS from "../../libs/axios/axiosCMS";
import { convertFormatedDate } from "../../utils/FunctionHelpers";

const ActiveUsers = ({ isOpen, onClose, selectedFilters }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const rowsPerPage = 5;

  const indexOfLastData = currentPage * rowsPerPage;
  const indexOfFirstData = indexOfLastData - rowsPerPage;

  /**
   * Fetches active user data based on selected filters.
   * @param {Object} filters - The filters to apply when fetching data.
   * 
   */
  const getData = useCallback(debounce(async (filters) => {
    setIsLoading(true);
    try {
      const URL = 'user-engagement/active_user_detail';
      const response = await axiosCMS.post(URL, filters);
      const result = response.data;
      setData(result.data);
    } catch (error) {
      console.error('Error fetching data: ', error);
    }
    setIsLoading(false);
  }, 1500), []);

  useEffect(() => {
    if (isOpen) {
      getData(selectedFilters);
      setCurrentPage(1);
    }
  }, [isOpen]);

  const dataPaginator = () => {
    const paginated = data.slice(indexOfFirstData, indexOfLastData);
    setPaginatedData(paginated);
  }

  useEffect(() => {
    dataPaginator();
  }, [currentPage, data]);

  const paginate = (direction) => {
    if (direction === 'next' && currentPage < Math.ceil(data.length / rowsPerPage)) {
      setCurrentPage(currentPage + 1);
    } else if (direction === 'prev' && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  }

  if (!isOpen) return null;

  return (
    <div className={`ue-active-user ${isOpen ? "open" : ""}`}>
      <div className="ue-active-user__content">
        <div className="ue-active-user__header">
          <h1 className="ue-active-user__title">Active Users</h1>
          <button className="ue-active-user__btn-close" onClick={onClose}>
            <img src={cancelIcon} alt="cancel icon" />
          </button>
        </div>
        <div className="ue-active-user__separator" />
        <div className="ue-active-user__section">
          <div className="ue-active-user__box">
            <table className="ue-active-user__table">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>
                    Role
                  </th>
                  <th style={{ width: '150px' }}>Last Activity Date</th>
                </tr>
              </thead>
              <tbody>
                {isLoading
                  ? <tr>
                    <td colSpan={3}><LoadingComponent message={'Loading data...'} /></td>
                  </tr>
                  : paginatedData.length !== 0
                    ? paginatedData.map((item, index) => (
                      <tr key={index}>
                        <td>{item.user_id}</td>
                        <td>{item.role?.role_name ?? '-'}</td>
                        <td>
                          {item.last_chat ? convertFormatedDate(item.last_chat) : "-"}
                        </td>
                      </tr>
                    ))
                    : <tr>
                      <td colSpan={3} className="text-center">No data available</td>
                    </tr>
                }
              </tbody>
            </table>
            <div className="ue-active-user__pagination">
              <button onClick={() => paginate('prev')} disabled={currentPage === 1}>Previous</button>
              <button onClick={() => paginate('next')} disabled={currentPage === (Math.ceil(data.length / rowsPerPage) >= 1? Math.ceil(data.length / rowsPerPage) : 1)}>Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ActiveUsers;